var PortfolioAppDefaults = {
	Categories: [{
		"label": "Salesforce",
		"value": "sfdc",
		"active": false
	}, {
		"label": "Jive",
		"value": "jive",
		"active": false
	}, {
		"label": "Wordpress",
		"value": "wordpress",
		"active": false
	}, {
		"label": "Development",
		"value": "development",
		"active": false
	}, {
		"label": "Design",
		"value": "design",
		"active": false
	}, {
		"label": "7Summits",
		"value": "sevens",
		"active": false
	}, {
		"label": "Journal Sentinel",
		"value": "journal",
		"active": false
	}, {
		"label": "Freelance",
		"value": "freelance",
		"active": false
	}]
};
